/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetadataField
 */
export interface MetadataField {
    /**
     * The name of the metadata field.
     * @type {string}
     * @memberof MetadataField
     */
    name: string;
    /**
     * When true, Metadata field is visible to the recipients of the envelope’s certificate of completion and
     * @type {boolean}
     * @memberof MetadataField
     */
    show: boolean;
    /**
     * The value of the metadata field
     * @type {string}
     * @memberof MetadataField
     */
    value: string;
}

/**
 * Check if a given object implements the MetadataField interface.
 */
export function instanceOfMetadataField(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('show' in value)) return false;
    if (!('value' in value)) return false;
    return true;
}

export function MetadataFieldFromJSON(json: any): MetadataField {
    return MetadataFieldFromJSONTyped(json, false);
}

export function MetadataFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetadataField {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'show': json['show'],
        'value': json['value'],
    };
}

export function MetadataFieldToJSON(value?: MetadataField | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'show': value['show'],
        'value': value['value'],
    };
}

